var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / filter-alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 3.99967C2.66602 3.63148 2.96449 3.33301 3.33268 3.33301H12.666C13.0342 3.33301 13.3327 3.63148 13.3327 3.99967C13.3327 4.36786 13.0342 4.66634 12.666 4.66634H3.33268C2.96449 4.66634 2.66602 4.36786 2.66602 3.99967Z",
    fill: "#667185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99935 7.99967C3.99935 7.63148 4.29783 7.33301 4.66602 7.33301H11.3327C11.7009 7.33301 11.9993 7.63148 11.9993 7.99967C11.9993 8.36786 11.7009 8.66634 11.3327 8.66634H4.66602C4.29783 8.66634 3.99935 8.36786 3.99935 7.99967Z",
    fill: "#667185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 11.333C5.63116 11.333 5.33268 11.6315 5.33268 11.9997C5.33268 12.3679 5.63116 12.6663 5.99935 12.6663H9.99935C10.3675 12.6663 10.666 12.3679 10.666 11.9997C10.666 11.6315 10.3675 11.333 9.99935 11.333H5.99935Z",
    fill: "#667185"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b8730b7d0b11e5fdc7ed244ace3865d2.svg";
export { ForwardRef as ReactComponent };